function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import {
    Slider,
    Picker
} from './components/components';
var PlayerInfo = function () {
    function PlayerInfo(player) {
        var _this = this;
        _classCallCheck(this, PlayerInfo);
        this.player = player;
        this.player.template.player_info_mask.addEventListener('click', function (e) {
            e.stopPropagation();
        });
        this.player.template.player_info_close.addEventListener('click', function () {
            _this.hide();
        });
        this.player.template.player_info_version.innerText = 'version '.concat(MFUNSPLAYER_VERSION);
    }
    _createClass(PlayerInfo, [
        {
            key: 'show',
            value: function show() {
                this.player.template.player_info_mask.classList.add('show');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.player_info_mask.classList.remove('show');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.player.template.player_info_mask.classList.contains('show'))
                    this.hide();
                else
                    this.show();
            }
        }
    ]);
    return PlayerInfo;
}();
export {
    PlayerInfo as default
};